import { InputSkeleton } from '@/_components';
import { CardContainer, SectionHeadingSkeleton } from '@/_containers';

export function TicketDetailsRightSectionLoading() {
  return (
    <>
      <CardContainer right>
        <div className="space-y-4">
          <SectionHeadingSkeleton withIcon={false} />

          <div className="mt-8 grid grid-cols-2 gap-x-3 gap-y-6">
            <div className="col-span-1">
              <InputSkeleton />
            </div>
            <div className="col-span-1">
              <InputSkeleton />
            </div>
            <div className="col-span-1">
              <InputSkeleton />
            </div>
            <div className="col-span-1">
              <InputSkeleton />
            </div>
            <div className="col-span-1">
              <InputSkeleton />
            </div>
            <div className="col-span-1">
              <InputSkeleton />
            </div>
            <div className="col-span-2">
              <InputSkeleton />
            </div>
          </div>
        </div>

        <section className="mt-6">
          <div className="space-y-4">
            <div className="mb-8">
              <SectionHeadingSkeleton withIcon={false} />
            </div>

            <InputSkeleton />
            <InputSkeleton />
            <InputSkeleton />
            <InputSkeleton />
          </div>
        </section>
      </CardContainer>
    </>
  );
}
